module.exports = __webpack_public_path__ + "img/area-chart-dark-01.6dc1fb5f.jpg";